import type { ReactElement, ReactNode } from 'react';
import { Button, Tooltip } from 'antd';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * 工具列按鈕尺寸：桌機維持 small（24px）；手機用預設尺寸（32px），手指點得到。
 */
export function useToolbarSize(): 'small' | 'middle' {
  return useIsMobile() ? 'middle' : 'small';
}

/** 桌機包 Tooltip；手機沒有 hover，Tooltip 只會在點擊後殘留，故直接回傳原節點。 */
export function withTip(mobile: boolean, title: string, node: ReactElement): ReactElement {
  return mobile ? node : <Tooltip title={title}>{node}</Tooltip>;
}

interface Props {
  active: boolean;
  icon: ReactNode;
  onClick: () => void;
  /** 說明文字：桌機為 Tooltip，兩者皆作為 aria-label。 */
  tip: string;
}

/** 編輯器工具列的單一格式按鈕（作用中時為 primary）。 */
export default function ToolbarButton({ active, icon, onClick, tip }: Props) {
  const mobile = useIsMobile();
  return withTip(
    mobile,
    tip,
    <Button
      size={mobile ? 'middle' : 'small'}
      type={active ? 'primary' : 'text'}
      icon={icon}
      aria-label={tip}
      onClick={onClick}
    />,
  );
}
